// import { getToken, getUser } from "../../../Helpers/Utils/Common";
import { getToken, getUser } from "../../Utilities/Common";
import {
  getWithParamsAPICall,
  postAPICall,
  postAPICallwithFile,
} from "../axiosMethodCall";

//POST API -- append a new data to the db
export const createLaboratory = async (info, is_lab_dependent) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("lab", info.lab ? info.lab : "");
    formData.append("test", info.test ? info.test : "");
    formData.append("unit", info.unit ? info.unit : "");
    formData.append("type", info.type ? info.type : "");
    formData.append("is_lab_dependent", is_lab_dependent);
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_tests/create",
      formData
    );
    return response;
  } catch (error) {
    return { error: error.response };
  }
};

export const getLabTests = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_tests/get_by_lab",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateLaboratory = async (info) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("lab_test_id", info.id);
    formData.append("lab", info.lab ? info.lab : "");
    formData.append("test", info.test ? info.test : "");
    formData.append("unit", info.unit ? info.unit : "");
    formData.append("type", info.type ? info.type : "");
    // formData.append("type", info.type ? info.type : "");

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_tests/update",
      formData
    );

    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteLaboratory = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "lab_tests/delete",
      {
        requester: getUser(),
        token: getToken(),
        lab_test_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createMultipleLabs = async (data) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());

    data.filteredDetails.forEach((lab) => {
      formData.append("patient_id[]", data.patient_id);
      formData.append("types[]", data.types);
      if (lab.lab_id) {
        formData.append("lab_test_id[]", lab.lab_id);
      }      
      // formData.append("result_date[]", data.selectedDate || '');
      if(data.types === "others"){
        formData.append("result_date[]", lab.result_date || '');
      } else {
        formData.append("result_date[]", data.selectedDate || '');
      }
      formData.append("result[]", lab.result || '');
      formData.append("attachments[]", lab.attachments || '');
      formData.append("lab_test_name[]", lab.lab_test_name || '');
      formData.append("doctor_id[]", data.doctor_id || '');
    });

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_results/create_multiple",
      formData,
      true
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateLabResult = async (data, doctorId) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("lab_result_id", data.id);
    formData.append("lab_test_id[]", data.lab_test_id);
    formData.append("patient_id", data.patient_id);
    formData.append("result", data.result || "");
    formData.append("result_date", data.result_date || null);
    // formData.append("attachments[]", data?.attachments || null);
    // formData.append("attachment_ids[]", data?.attachments?.id || null);
    if (data?.attachments?.id) {
      formData.append("attachment_ids[]", data.attachments.id);
    } else if (data?.attachments) {
      formData.append("attachments[]", data.attachments);
    }
    formData.append("lab_test_name[]", data.lab_test_name || null);
    formData.append("types[]", data.lab_type_name);
    formData.append("doctor_id[]", doctorId || '');

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_results/update",
      formData,
      true
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteLabResult = async (lab_result_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "lab_results/delete",
      {
        requester: getUser(),
        token: getToken(),
        lab_result_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getLabResults = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_results/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
